import { render, staticRenderFns } from "./account-management-search.vue?vue&type=template&id=523e24a3&scoped=true"
import script from "./account-management-search.vue?vue&type=script&lang=js"
export * from "./account-management-search.vue?vue&type=script&lang=js"
import style0 from "./account-management-search.vue?vue&type=style&index=0&id=523e24a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e24a3",
  null
  
)

export default component.exports